import { render, staticRenderFns } from "./UserUpsertForm.vue?vue&type=template&id=1b832f04&"
import script from "./UserUpsertForm.vue?vue&type=script&lang=ts&"
export * from "./UserUpsertForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports